import { RadioButtonsField } from "./fields.js";

export class ObjectModificationRadioButtons extends RadioButtonsField {
	constructor () {
		super ();
		this.name = "object-modification";
		this.options = [
			{ title: "Extension de l'objet social", value: "1" },
			{ title: "Modification de l'objet social", value: "2" },
		];
		this.value = "1";
	}
}

customElements.define("object-modification-radiobuttons", ObjectModificationRadioButtons);
